import { useTranslation } from '@thoughtspot/i18n';
import cx from 'classnames';
import _ from 'lodash';
import React from 'react';
import { getOnEnter } from '../../_utils';
import { Icon, IconID } from '../../icon';
import { Typography } from '../../typography';
import styles from '../stepper.module.scss';
export const StepperItem = ({ stepNumber, isActive, isCompleted, title, isSequential, orientation, onClick, }) => {
    const stepItemMainClass = cx(styles.stepItemMain, {
        [styles.isCompleted]: isCompleted,
        [styles.isActive]: isActive,
    });
    const { t } = useTranslation();
    const renderStepCircleContent = () => {
        let ariaLabel = `${t('STEP')} ${stepNumber + 1}`;
        if (title && typeof title === 'string') {
            ariaLabel += `, ${title}`;
        }
        if (isSequential && !!isCompleted) {
            ariaLabel += `, ${t('Completed')}`;
        }
        const stepCircleContent = (React.createElement(Typography, { variant: "body-normal", overrideTag: "span", className: styles.stepCircleContent, "aria-label": ariaLabel }, isSequential && !isCompleted ? (stepNumber + 1) : (React.createElement(Icon, { id: IconID.CHECKMARK, className: styles.stepIcon }))));
        const tooltipConfig = orientation === 'horizontal'
            ? {
                'data-tooltip-content': title,
                'data-tooltip-position': 'bottom',
            }
            : {};
        return (React.createElement("div", { className: styles.stepCircle, ...tooltipConfig }, stepCircleContent));
    };
    const renderStepTitle = () => {
        if (orientation === 'vertical') {
            if (_.isString(title)) {
                const ellipsis = isSequential ? { rows: 1 } : undefined;
                const tooltipConfig = {
                    dataTooltipContent: title,
                    dataTooltipPosition: 'right',
                    showTooltipOnlyOnEllipsis: orientation === 'vertical',
                };
                return (React.createElement(Typography, { variant: "body-normal", className: styles.stepTitle, ellipsis: ellipsis, tooltipConfig: tooltipConfig, noMargin: true }, title));
            }
            return React.createElement("div", { className: styles.stepTitle }, title);
        }
        return null;
    };
    // Always clickable when Stepper is Non-Sequential. In case of Sequential Stepper, only clickable for the steps which are completed.
    const isClickable = !!(onClick &&
        ((isSequential && isCompleted) || !isSequential));
    const onStepItemClick = (event, stepItemNumber) => {
        event.stopPropagation();
        if (isClickable) {
            onClick(stepItemNumber);
        }
    };
    const stepItemClass = cx(styles.stepItem, {
        [styles.isClickable]: isClickable,
    });
    return (React.createElement("div", { className: stepItemMainClass },
        React.createElement("div", { className: stepItemClass, onClick: (event) => onStepItemClick(event, stepNumber), role: "tab", "aria-current": !!isActive, tabIndex: isClickable ? 0 : -1, onKeyDown: getOnEnter((event) => onStepItemClick(event, stepNumber)) },
            renderStepCircleContent(),
            renderStepTitle()),
        isSequential && React.createElement("div", { className: styles.connector })));
};
//# sourceMappingURL=stepper-item.js.map